import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'splash-dialog-component',
    template: `
<h1 mat-dialog-title>{{title}}</h1>
<div mat-dialog-content>{{message}}</div>
<mat-progress-bar *ngIf="showProgress" mode="indeterminate"></mat-progress-bar>
`
})
export class SplashDialogComponent {
    title: string;
    message: string;
    showProgress: boolean;

    constructor(public dialogRef: MatDialogRef<SplashDialogComponent>, @Inject(MAT_DIALOG_DATA) private data: _SplashOptions) {
        this.title = data.TitleText;
        this.message = data.MessageText;
        this.showProgress = data.ShowProgressBar;
    }
}

// #region Custom Classes

    // #region Splash Options Class

        export class _SplashOptions {
            TitleText?: string;
            MessageText?: string;
            ShowProgressBar?: boolean;
        }

    // #endregion

// #endregion


// WEBPACK FOOTER //
// ./src/services/splash/splash.component.ts